import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayPendingConfigOPEEnum} from "./GatewayPendingConfigOPEEnum";
import {DeviceDraftDTO} from "./GatewayPendingConfigPayloadDTO";

class O {
  gatewayId!: number;
  updateTs?: string;
  device!: DeviceDraftDTO;
}

class I {
  gatewayId!: number;
  device!: DeviceDraftDTO;
}

export class SaveDevicePendingConfigCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(GatewayPendingConfigOPEEnum.SaveDevicePendingConfig);
    this.i = new I();
    this.o = new O();
  }
}
